export interface Feature {
  title: string;
  description: string;
  icon: string; // heroicon name for lookup
  details: string[];
}

export interface FeatureCategory {
  name: string;
  tagline: string;
  features: Feature[];
}

export const featureHighlights: Feature[] = [
  {
    title: 'Observation Tracking',
    description: 'Capture rich narrative observations with photos and videos, linked to CAPS learning areas.',
    icon: 'eye',
    details: [
      'Rich text narrative observations',
      'Photo and video attachments',
      'Link to CAPS Learning Areas & Outcomes',
      'Milestone and concern flagging',
      'Bulk observation entry',
      'Local-LLM AI assist (polish drafts, suggest CAPS outcomes — runs on-prem, no third-party AI)',
    ],
  },
  {
    title: 'CAPS-Aligned Assessments',
    description: 'Structured assessments mapped to the South African CAPS curriculum for Grades R-3.',
    icon: 'clipboard-document-check',
    details: [
      'Pre-loaded CAPS Learning Areas',
      'Configurable rating scales',
      'Grade R through Grade 3 coverage',
      'Progress tracking over time',
      'Assessment report generation',
    ],
  },
  {
    title: 'Parent Portal',
    description: 'Give families a window into their child\'s learning journey with a secure guardian portal.',
    icon: 'user-group',
    details: [
      'Published observations and assessments',
      'Secure invitation-based access',
      'Mobile-friendly interface',
      'Real-time email notifications',
      'POPIA-compliant data sharing',
    ],
  },
  {
    title: 'Reports & Analytics',
    description: 'Generate professional reports and gain insights into learning progress across your centre.',
    icon: 'chart-bar',
    details: [
      'Individual child progress reports',
      'Classroom-level analytics',
      'Learning area coverage reports',
      'Exportable PDF reports',
      'Dashboard with key metrics',
    ],
  },
];

export const featureCategories: FeatureCategory[] = [
  {
    name: 'For Directors',
    tagline: 'Run your centre with confidence',
    features: [
      {
        title: 'Multi-Classroom Management',
        description: 'Oversee all classrooms, teachers, and children from a single dashboard.',
        icon: 'building-office',
        details: [],
      },
      {
        title: 'Staff Management',
        description: 'Manage teacher accounts, assign roles, and control permissions.',
        icon: 'users',
        details: [],
      },
      {
        title: 'Compliance Ready',
        description: 'POPIA-compliant data handling with consent management and audit logs.',
        icon: 'shield-check',
        details: [],
      },
    ],
  },
  {
    name: 'For Teachers',
    tagline: 'Focus on what matters — the children',
    features: [
      {
        title: 'Quick Capture',
        description: 'Record observations on the go with mobile-friendly forms and photo capture.',
        icon: 'camera',
        details: [],
      },
      {
        title: 'Curriculum Mapping',
        description: 'Easily link observations to CAPS outcomes without memorising codes.',
        icon: 'academic-cap',
        details: [],
      },
      {
        title: 'Progress Overview',
        description: 'See each child\'s development journey at a glance across all learning areas.',
        icon: 'presentation-chart-line',
        details: [],
      },
    ],
  },
  {
    name: 'For Parents',
    tagline: 'Stay connected to your child\'s learning',
    features: [
      {
        title: 'Learning Updates',
        description: 'Receive email notifications when new observations or assessments are published.',
        icon: 'bell',
        details: [],
      },
      {
        title: 'Secure Portal',
        description: 'Access your child\'s records anytime through a private, invitation-only portal.',
        icon: 'lock-closed',
        details: [],
      },
      {
        title: 'Progress Tracking',
        description: 'Follow your child\'s development over time with clear, easy-to-understand reports.',
        icon: 'arrow-trending-up',
        details: [],
      },
    ],
  },
];
